import { RouteObject } from 'react-router-dom';
import ErrorPage from 'src/error-page';
import { lazyConReintento } from 'src/config/lazy-con-reintento';
import { diferida } from 'src/config/pagina-diferida';

const TuShortlistLandingView = lazyConReintento(() => import('./tushortlist'));

/**
 * Landings públicas de captación. Van al primer nivel del árbol de rutas, fuera de cualquier layout:
 * en esta app el login lo fuerza el layout, así que colgar de aquí es lo que las mantiene anónimas.
 */
const landingRoutes: RouteObject[] = [
  {
    path: '/landings/tushortlist',
    element: diferida(<TuShortlistLandingView />),
    errorElement: <ErrorPage />
  }
];

export default landingRoutes;
